import { ReactElement, useCallback, useEffect, Suspense } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { useRecoilValue } from 'recoil'
import UserForm from '../../forms/user-form'
import axios from 'axios'
import { getServerHost } from '../../utils/get-server-host'
import { getHeaders } from '../../utils/get-headers'
import { useNavigate, useParams } from 'react-router'
import { userState } from '../../states/user-state'
import { useFetchUser } from '../../hooks/use-fetch-user'
import { ScreenTitle } from '../../components/screen-title/screen-title'
import { useUpdateUser } from '../../hooks/use-update-user'

const UserDetailScreen = (): ReactElement => {
  const { userId } = useParams()

  const user = useRecoilValue(userState(userId))
  const navigate = useNavigate()
  const fetchUser = useFetchUser({ userId })

  const removeUser = useCallback(async () => {
    navigate('/admin/users')

    await axios.delete(getServerHost(`user/${userId}`), {
      headers: getHeaders(),
    })
  }, [])

  const updateUser = useUpdateUser({ userId })

  useEffect(() => {
    if (!user) {
      // If no user found fetch it
      fetchUser().catch(() => {
        console.log('error')
      })
    }
  }, [])

  return (
    <Flexbox isCol flex={1}>
      <ScreenTitle title={`${user?.firstName} ${user?.lastName}`} />
      User detail for user #{user?.firstName} {user?.lastName} {user?.registeredAt?.toString()}
      <Suspense>
        {user && (
          <UserForm
            initialValues={user}
            excludedFields={['password']}
            buttonTitle="Update"
            onSubmit={updateUser}
          />
        )}
      </Suspense>
      <Flexbox alignItems="flex-end" flex={1} justifyContent="flex-end">
        <button className="btn btn-warning mt-8" onClick={removeUser}>
          Delete
        </button>
      </Flexbox>
    </Flexbox>
  )
}

export default UserDetailScreen